import { graphql } from "@/lib/gql/__generated__";
import { ReservationRequestStatus } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { useHotelApplicationDataQuery } from "@/components/features/_shared/repository/hotel-application-data/query";

const SideMenu_Query = graphql(/* GraphQL */ `
	query SideMenuMobile($hotelID: ID!, $months: Int!, $reservationRequestStatus: ReservationRequestStatus!) {
		hpbSettings(hotelID: $hotelID) {
			id
			hotelID
			ownerType
			domainName
		}
		hotel(hotelID: $hotelID) {
			id
			name
		}
		reservationRequestListByMonthCount(
			hotelID: $hotelID
			months: $months
			reservationRequestStatus: $reservationRequestStatus
		) {
			id
			hotelID
			hotelName
			reservations {
				hotelID
				reservationID
				reservationType
				reservationStatus
			}
		}
	}
`);

type Props = {
	hotelID: string;
};

export const useSideMenuMobile = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(SideMenu_Query, {
		variables: { hotelID, months: 3, reservationRequestStatus: ReservationRequestStatus.Unnoticed },
	});

	const { hotelApplicationData } = useHotelApplicationDataQuery(hotelID);

	return {
		sideMenuData: data,
		hotelApplicationData: {
			hotelApplicationStatus: {
				isHotelPolicyRegistered: hotelApplicationData?.hotelApplicationStatus.isHotelPolicyRegistered || false,
				isHotelRegistered: hotelApplicationData?.hotelApplicationStatus.isHotelRegistered || false,
				validDtEndBasicInitialSetUp:
					hotelApplicationData?.hotelApplicationStatus.validDtEndBasicInitialSetUp || null,
			},
		},
	};
};
